import React from "react";

import MateriaMedica from "./MateriaMedica";
import Repertorio from "./Repertorio";
import Homeosiniatria from "./Homeosiniatria";
import Atlas from "./Atlas";
import Enfermedades from "./Enfermedades";
import Heel from "./Heel";

const LIBRO_MAP = {
  1: "Homeosiniatria",
  2: "Enfermedades",
  3: "Atlas",
  4: "Kent-repertorio",
  5: "Vinovsky",
  6: "Clarke",
  7: "Nash",
  8: "Kent",
  9: "Lathoud",
  10: "Farrington",
  11: "Paschero",
  12: "Heel",
};

const DetalleLibro = (props) => {
  const navWithQueryParams = props.location.pathname.split("/");
  const nav = navWithQueryParams[navWithQueryParams.length - 1].split("?");
  const libNumber = nav[0];

  const autor = LIBRO_MAP[libNumber] || null;

  switch (autor) {
    case "Kent-repertorio":
      return <Repertorio />;
    case "Homeosiniatria":
      return <Homeosiniatria />;
    case "Atlas":
      return <Atlas />;
    case "Enfermedades":
      return <Enfermedades />;
    case "Heel":
      return <Heel {...props} />;
    case null:
      return null;
    default:
      return <MateriaMedica autor={autor} />;
  }
};

export default DetalleLibro;
